import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '8px 0 8px 8px',
    alignItems: 'flex-start',
    position: 'relative',
  },
  containerWithGuests: {
    position: 'relative',
    '::after': {
      content: '""',
      position: 'absolute',
      left: '15px',
      top: '40px',
      bottom: '8px',
      width: '1px',
      backgroundColor: colors.tertiaryBorder,
    },
  },
  disabledRow: {
    opacity: 0.5,
  },
  containerTab: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    gap: anatomy['space-20'],
  },
  participantInfoBlock: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
  },
  statusAndActionsBlock: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
    flex: 1,
    justifyContent: 'space-between',
  },

  checkbox: {
    display: 'flex',
    padding: '4px 0',
    alignItems: 'flex-start',
    gap: anatomy['space-10'],
    alignSelf: 'stretch',
  },
  personCard: {
    display: 'flex',
    width: '220px',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  personDescription: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '5px',
    alignSelf: 'stretch',
  },
  statusWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'flex-start',
  },

  photo: {
    width: '36px',
    height: '36px',
    border: `1px solid ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusXxl,

    margin: '0 8px',
  },
  firstName: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightCaption-1'],
    overflow: 'hidden',
    color: colors.primaryText,
    textOverflow: 'ellipsis',
  },
  position: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-2'],
    overflow: 'hidden',
    color: colors.secondaryText,
    textOverflow: 'ellipsis',
  },

  guestsInfoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: anatomy.borderRadiusXs,
    background: colors.deepBackground,
    gap: '4px',
  },

  guestsChips: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
  },

  guestChip: {
    display: 'flex',
    padding: `${anatomy['space-4']} ${anatomy['space-8']}`,
    alignItems: 'center',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    color: colors.primaryText,
  },

  detailsButton: {
    display: 'flex',
    width: '67px',
    padding: `${anatomy['space-4']} ${anatomy['space-10']}`,
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    color: colors.accentText,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
      textUnderlineOffset: '1px',
    },
  },

  statuses: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-12'],
  },
  statusBlock: {
    display: 'flex',
    paddingTop: '2px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
    alignSelf: 'stretch',
  },

  statusBlockItem: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-20'],
  },
  dataBlock: {
    display: 'flex',
    paddingTop: '2px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
    alignSelf: 'stretch',
  },

  dataBlockItem: {
    display: 'flex',
    gap: anatomy['space-20'],
  },

  dataBlockTitle: {
    display: 'flex',
    width: '72px',
    alignItems: 'center',
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightCaption-2'],
    color: colors.primaryText,
  },

  dataFields: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-20'],
  },

  dataField: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-4'],
    alignSelf: 'stretch',
    minWidth: '118px',
  },

  statusField: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-4'],
    width: '118px',
  },

  dataFieldLabel: {
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-3'],
  },

  dataFieldValue: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-3'],
  },

  invitationStatusesTitleBlock: {
    display: 'flex',
    width: '160px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  invitationTitle: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    lineHeight: typography['lineHeightCaption-2'],
  },
  invitationStatusBlock: {
    display: 'flex',
    padding: '2px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: anatomy.borderRadiusRound,
    background: palette['green-200'],
    cursor: 'pointer',
    color: palette['green-700'],
    border: 'none',
  },

  invitationStatus: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },
  invitationStatusIcon: {
    display: 'flex',
    cursor: 'pointer',
  },
  invitationStatusContainer: {
    position: 'relative',
  },
  invitationStatusDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    marginTop: '4px',
    width: '241px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.primaryBackground,
    borderRadius: anatomy.borderRadiusS,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    border: `1px solid ${colors.tertiaryBorder}`,
    zIndex: 1000,
    padding: anatomy['space-4'],
  },
  invitationStatusDropdownItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${anatomy['space-8']} ${anatomy['space-12']}`,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: colors.hoverBackground,
      borderRadius: anatomy.borderRadiusXs,
    },
  },
  invitationStatusDropdownText: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
  },
  confirmationAlert: {
    width: '372px',
    display: 'flex',
    padding: '8px 16px',
    borderRadius: anatomy.borderRadiusM,
    backgroundColor: colors.infoBackground,
    zIndex: 1000,
    gap: anatomy['space-8'],
  },
  confirmationAlertContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
  },
  confirmationAlertText: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
  confirmationAlertButtons: {
    display: 'flex',
    gap: anatomy['space-8'],
    width: '100%',
  },
  statusTitle: {
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },
  sendStatus: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },
  borderIcon: {
    width: '100%',
    height: '1px',
    backgroundColor: colors.tertiaryBorder,
  },

  actions: {
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    gap: anatomy['space-8'],
  },

  actionsIcon: {
    display: 'flex',
    padding: '4px',
    cursor: 'pointer',
    transition: 'color 0.2s ease-in-out',
    ':hover svg path': {
      fill: colors.accentIcon,
    },
  },

  actionsIconStroke: {
    display: 'flex',
    padding: '4px',
    cursor: 'pointer',
    transition: 'color 0.2s ease-in-out',

    ':hover svg path': {
      stroke: colors.accentIcon,
    },
  },

  infoTooltip: {
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    borderRadius: anatomy.borderRadiusS,
    background: colors.primaryInverseBackground,
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: anatomy['space-8'],
  },
  titleRow: {
    color: 'var(--foreground-tertiary, #8E9296)',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-5'],
  },
  statusRow: {
    color: 'var(--foreground-primary-inverse, #FFF)',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-5'],
  },
  checkboxDis: {
    width: '18px',
    height: '18px',
    cursor: 'not-allowed',
  },
  inactivePosition: {
    display: 'flex',
    padding: '2px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: anatomy['space-8'],
    borderRadius: anatomy.borderRadiusRound,
    background: palette['rose-100'],
  },
  inactivePositionText: {
    color: colors.errorText,
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },

  invitationStatusBlockWarning: {
    background: palette['yellow-200'],
    color: palette['yellow-700'],
  },

  invitationStatusBlockWait: {
    background: palette['grey-100'],
    color: palette['grey-700'],
  },
  invitationStatusDropdownItemDisabled: {
    opacity: 0.5,
  },
  customButton: {
    display: 'flex',
    padding: '4px 12px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: anatomy.borderRadiusXs,
    border: `1px solid ${colors.primaryBorder}`,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-5'],
    color: colors.primaryText,
    ':hover': {
      backgroundColor: colors.hoverBackground,
      borderColor: colors.hoverBorder,
    },
    ':active': {
      backgroundColor: colors.activeBackground,
    },
  },
  guestsTreeContainer: {
    display: 'flex',
    paddingLeft: anatomy['space-20'],
    alignItems: 'flex-start',
    gap: anatomy['space-12'],
    width: '100%',
    boxSizing: 'border-box',
    alignSelf: 'stretch',
  },
  guestsTreeLine: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: anatomy['space-20'],
    gap: anatomy['space-8'],
    width: '100%',
    boxSizing: 'border-box',
  },
  guestSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
    width: '100%',
  },
  guestSectionTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-8'],
    paddingLeft: anatomy['space-4'],
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightCaption-1'],
    position: 'relative',
    right: '20px',
  },
  guestsTreeChildren: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: anatomy['space-12'],
    gap: anatomy['space-12'],
    borderLeft: `1px solid ${colors.tertiaryBorder}`,
    width: '100%',
    boxSizing: 'border-box',
  },
  guestCardRow: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-8'],
    padding: `${anatomy['space-16']} ${anatomy['space-4']} ${anatomy['space-8']} ${anatomy['space-4']}`,
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: anatomy['space-40'],
  },
});
